// source: contentversion/contentversion.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.contentversion.ContentVersionRecord', null, global);
goog.exportSymbol('proto.contentversion.DownloadContentVersionRequest', null, global);
goog.exportSymbol('proto.contentversion.DownloadContentVersionResponse', null, global);
goog.exportSymbol('proto.contentversion.EntityDiffSummary', null, global);
goog.exportSymbol('proto.contentversion.GetAvailableUpgradeRequest', null, global);
goog.exportSymbol('proto.contentversion.GetAvailableUpgradeResponse', null, global);
goog.exportSymbol('proto.contentversion.GetContentVersionRequest', null, global);
goog.exportSymbol('proto.contentversion.ListContentVersionsResponse', null, global);
goog.exportSymbol('proto.contentversion.PreviewContentVersionResponse', null, global);
goog.exportSymbol('proto.contentversion.PublishContentVersionRequest', null, global);
goog.exportSymbol('proto.contentversion.PublishContentVersionStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.PublishContentVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.PublishContentVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.PublishContentVersionRequest.displayName = 'proto.contentversion.PublishContentVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.PreviewContentVersionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.PreviewContentVersionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.PreviewContentVersionResponse.displayName = 'proto.contentversion.PreviewContentVersionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.EntityDiffSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.EntityDiffSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.EntityDiffSummary.displayName = 'proto.contentversion.EntityDiffSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.ListContentVersionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.contentversion.ListContentVersionsResponse.repeatedFields_, null);
};
goog.inherits(proto.contentversion.ListContentVersionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.ListContentVersionsResponse.displayName = 'proto.contentversion.ListContentVersionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.GetContentVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.GetContentVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.GetContentVersionRequest.displayName = 'proto.contentversion.GetContentVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.GetAvailableUpgradeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.GetAvailableUpgradeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.GetAvailableUpgradeRequest.displayName = 'proto.contentversion.GetAvailableUpgradeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.GetAvailableUpgradeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.GetAvailableUpgradeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.GetAvailableUpgradeResponse.displayName = 'proto.contentversion.GetAvailableUpgradeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.DownloadContentVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.DownloadContentVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.DownloadContentVersionRequest.displayName = 'proto.contentversion.DownloadContentVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.DownloadContentVersionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.DownloadContentVersionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.DownloadContentVersionResponse.displayName = 'proto.contentversion.DownloadContentVersionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentversion.ContentVersionRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentversion.ContentVersionRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentversion.ContentVersionRecord.displayName = 'proto.contentversion.ContentVersionRecord';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.PublishContentVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.PublishContentVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.PublishContentVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.PublishContentVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    isMajor: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    changelog: jspb.Message.getFieldWithDefault(msg, 6, ""),
    initialMajorVersion: jspb.Message.getFieldWithDefault(msg, 7, 0),
    initialMinorVersion: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.PublishContentVersionRequest}
 */
proto.contentversion.PublishContentVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.PublishContentVersionRequest;
  return proto.contentversion.PublishContentVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.PublishContentVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.PublishContentVersionRequest}
 */
proto.contentversion.PublishContentVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMajor(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangelog(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInitialMajorVersion(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInitialMinorVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.PublishContentVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.PublishContentVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.PublishContentVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.PublishContentVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsMajor();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChangelog();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional bool is_major = 2;
 * @return {boolean}
 */
proto.contentversion.PublishContentVersionRequest.prototype.getIsMajor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.contentversion.PublishContentVersionRequest} returns this
 */
proto.contentversion.PublishContentVersionRequest.prototype.setIsMajor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.contentversion.PublishContentVersionRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.PublishContentVersionRequest} returns this
 */
proto.contentversion.PublishContentVersionRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string changelog = 6;
 * @return {string}
 */
proto.contentversion.PublishContentVersionRequest.prototype.getChangelog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.PublishContentVersionRequest} returns this
 */
proto.contentversion.PublishContentVersionRequest.prototype.setChangelog = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 initial_major_version = 7;
 * @return {number}
 */
proto.contentversion.PublishContentVersionRequest.prototype.getInitialMajorVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.PublishContentVersionRequest} returns this
 */
proto.contentversion.PublishContentVersionRequest.prototype.setInitialMajorVersion = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.contentversion.PublishContentVersionRequest} returns this
 */
proto.contentversion.PublishContentVersionRequest.prototype.clearInitialMajorVersion = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PublishContentVersionRequest.prototype.hasInitialMajorVersion = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 initial_minor_version = 8;
 * @return {number}
 */
proto.contentversion.PublishContentVersionRequest.prototype.getInitialMinorVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.PublishContentVersionRequest} returns this
 */
proto.contentversion.PublishContentVersionRequest.prototype.setInitialMinorVersion = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.contentversion.PublishContentVersionRequest} returns this
 */
proto.contentversion.PublishContentVersionRequest.prototype.clearInitialMinorVersion = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PublishContentVersionRequest.prototype.hasInitialMinorVersion = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.PreviewContentVersionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.PreviewContentVersionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.PreviewContentVersionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    controls: (f = msg.getControls()) && proto.contentversion.EntityDiffSummary.toObject(includeInstance, f),
    policies: (f = msg.getPolicies()) && proto.contentversion.EntityDiffSummary.toObject(includeInstance, f),
    testProcedures: (f = msg.getTestProcedures()) && proto.contentversion.EntityDiffSummary.toObject(includeInstance, f),
    frameworks: (f = msg.getFrameworks()) && proto.contentversion.EntityDiffSummary.toObject(includeInstance, f),
    frameworkSections: (f = msg.getFrameworkSections()) && proto.contentversion.EntityDiffSummary.toObject(includeInstance, f),
    frameworkRequirements: (f = msg.getFrameworkRequirements()) && proto.contentversion.EntityDiffSummary.toObject(includeInstance, f),
    departments: (f = msg.getDepartments()) && proto.contentversion.EntityDiffSummary.toObject(includeInstance, f),
    suggestedChangelog: jspb.Message.getFieldWithDefault(msg, 8, ""),
    isFirstPublish: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    latestMajorVersion: jspb.Message.getFieldWithDefault(msg, 10, 0),
    latestMinorVersion: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.PreviewContentVersionResponse}
 */
proto.contentversion.PreviewContentVersionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.PreviewContentVersionResponse;
  return proto.contentversion.PreviewContentVersionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.PreviewContentVersionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.PreviewContentVersionResponse}
 */
proto.contentversion.PreviewContentVersionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.contentversion.EntityDiffSummary;
      reader.readMessage(value,proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader);
      msg.setControls(value);
      break;
    case 2:
      var value = new proto.contentversion.EntityDiffSummary;
      reader.readMessage(value,proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader);
      msg.setPolicies(value);
      break;
    case 3:
      var value = new proto.contentversion.EntityDiffSummary;
      reader.readMessage(value,proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader);
      msg.setTestProcedures(value);
      break;
    case 4:
      var value = new proto.contentversion.EntityDiffSummary;
      reader.readMessage(value,proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader);
      msg.setFrameworks(value);
      break;
    case 5:
      var value = new proto.contentversion.EntityDiffSummary;
      reader.readMessage(value,proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader);
      msg.setFrameworkSections(value);
      break;
    case 6:
      var value = new proto.contentversion.EntityDiffSummary;
      reader.readMessage(value,proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader);
      msg.setFrameworkRequirements(value);
      break;
    case 7:
      var value = new proto.contentversion.EntityDiffSummary;
      reader.readMessage(value,proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader);
      msg.setDepartments(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuggestedChangelog(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFirstPublish(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLatestMajorVersion(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLatestMinorVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.PreviewContentVersionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.PreviewContentVersionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.PreviewContentVersionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControls();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.contentversion.EntityDiffSummary.serializeBinaryToWriter
    );
  }
  f = message.getPolicies();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.contentversion.EntityDiffSummary.serializeBinaryToWriter
    );
  }
  f = message.getTestProcedures();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.contentversion.EntityDiffSummary.serializeBinaryToWriter
    );
  }
  f = message.getFrameworks();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.contentversion.EntityDiffSummary.serializeBinaryToWriter
    );
  }
  f = message.getFrameworkSections();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.contentversion.EntityDiffSummary.serializeBinaryToWriter
    );
  }
  f = message.getFrameworkRequirements();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.contentversion.EntityDiffSummary.serializeBinaryToWriter
    );
  }
  f = message.getDepartments();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.contentversion.EntityDiffSummary.serializeBinaryToWriter
    );
  }
  f = message.getSuggestedChangelog();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsFirstPublish();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getLatestMajorVersion();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getLatestMinorVersion();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional EntityDiffSummary controls = 1;
 * @return {?proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getControls = function() {
  return /** @type{?proto.contentversion.EntityDiffSummary} */ (
    jspb.Message.getWrapperField(this, proto.contentversion.EntityDiffSummary, 1));
};


/**
 * @param {?proto.contentversion.EntityDiffSummary|undefined} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
*/
proto.contentversion.PreviewContentVersionResponse.prototype.setControls = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.clearControls = function() {
  return this.setControls(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.hasControls = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EntityDiffSummary policies = 2;
 * @return {?proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getPolicies = function() {
  return /** @type{?proto.contentversion.EntityDiffSummary} */ (
    jspb.Message.getWrapperField(this, proto.contentversion.EntityDiffSummary, 2));
};


/**
 * @param {?proto.contentversion.EntityDiffSummary|undefined} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
*/
proto.contentversion.PreviewContentVersionResponse.prototype.setPolicies = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.clearPolicies = function() {
  return this.setPolicies(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.hasPolicies = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EntityDiffSummary test_procedures = 3;
 * @return {?proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getTestProcedures = function() {
  return /** @type{?proto.contentversion.EntityDiffSummary} */ (
    jspb.Message.getWrapperField(this, proto.contentversion.EntityDiffSummary, 3));
};


/**
 * @param {?proto.contentversion.EntityDiffSummary|undefined} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
*/
proto.contentversion.PreviewContentVersionResponse.prototype.setTestProcedures = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.clearTestProcedures = function() {
  return this.setTestProcedures(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.hasTestProcedures = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional EntityDiffSummary frameworks = 4;
 * @return {?proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getFrameworks = function() {
  return /** @type{?proto.contentversion.EntityDiffSummary} */ (
    jspb.Message.getWrapperField(this, proto.contentversion.EntityDiffSummary, 4));
};


/**
 * @param {?proto.contentversion.EntityDiffSummary|undefined} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
*/
proto.contentversion.PreviewContentVersionResponse.prototype.setFrameworks = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.clearFrameworks = function() {
  return this.setFrameworks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.hasFrameworks = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional EntityDiffSummary framework_sections = 5;
 * @return {?proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getFrameworkSections = function() {
  return /** @type{?proto.contentversion.EntityDiffSummary} */ (
    jspb.Message.getWrapperField(this, proto.contentversion.EntityDiffSummary, 5));
};


/**
 * @param {?proto.contentversion.EntityDiffSummary|undefined} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
*/
proto.contentversion.PreviewContentVersionResponse.prototype.setFrameworkSections = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.clearFrameworkSections = function() {
  return this.setFrameworkSections(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.hasFrameworkSections = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional EntityDiffSummary framework_requirements = 6;
 * @return {?proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getFrameworkRequirements = function() {
  return /** @type{?proto.contentversion.EntityDiffSummary} */ (
    jspb.Message.getWrapperField(this, proto.contentversion.EntityDiffSummary, 6));
};


/**
 * @param {?proto.contentversion.EntityDiffSummary|undefined} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
*/
proto.contentversion.PreviewContentVersionResponse.prototype.setFrameworkRequirements = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.clearFrameworkRequirements = function() {
  return this.setFrameworkRequirements(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.hasFrameworkRequirements = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EntityDiffSummary departments = 7;
 * @return {?proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getDepartments = function() {
  return /** @type{?proto.contentversion.EntityDiffSummary} */ (
    jspb.Message.getWrapperField(this, proto.contentversion.EntityDiffSummary, 7));
};


/**
 * @param {?proto.contentversion.EntityDiffSummary|undefined} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
*/
proto.contentversion.PreviewContentVersionResponse.prototype.setDepartments = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.clearDepartments = function() {
  return this.setDepartments(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.hasDepartments = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string suggested_changelog = 8;
 * @return {string}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getSuggestedChangelog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.setSuggestedChangelog = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool is_first_publish = 9;
 * @return {boolean}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getIsFirstPublish = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.setIsFirstPublish = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int32 latest_major_version = 10;
 * @return {number}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getLatestMajorVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.setLatestMajorVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 latest_minor_version = 11;
 * @return {number}
 */
proto.contentversion.PreviewContentVersionResponse.prototype.getLatestMinorVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.PreviewContentVersionResponse} returns this
 */
proto.contentversion.PreviewContentVersionResponse.prototype.setLatestMinorVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.EntityDiffSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.EntityDiffSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.EntityDiffSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.EntityDiffSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    added: jspb.Message.getFieldWithDefault(msg, 1, 0),
    modified: jspb.Message.getFieldWithDefault(msg, 2, 0),
    removed: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.EntityDiffSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.EntityDiffSummary;
  return proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.EntityDiffSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.EntityDiffSummary}
 */
proto.contentversion.EntityDiffSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdded(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setModified(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRemoved(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.EntityDiffSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.EntityDiffSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.EntityDiffSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.EntityDiffSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdded();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getModified();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRemoved();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 added = 1;
 * @return {number}
 */
proto.contentversion.EntityDiffSummary.prototype.getAdded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.EntityDiffSummary} returns this
 */
proto.contentversion.EntityDiffSummary.prototype.setAdded = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 modified = 2;
 * @return {number}
 */
proto.contentversion.EntityDiffSummary.prototype.getModified = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.EntityDiffSummary} returns this
 */
proto.contentversion.EntityDiffSummary.prototype.setModified = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 removed = 3;
 * @return {number}
 */
proto.contentversion.EntityDiffSummary.prototype.getRemoved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.EntityDiffSummary} returns this
 */
proto.contentversion.EntityDiffSummary.prototype.setRemoved = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.contentversion.ListContentVersionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.ListContentVersionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.ListContentVersionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.ListContentVersionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.ListContentVersionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.contentversion.ContentVersionRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.ListContentVersionsResponse}
 */
proto.contentversion.ListContentVersionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.ListContentVersionsResponse;
  return proto.contentversion.ListContentVersionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.ListContentVersionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.ListContentVersionsResponse}
 */
proto.contentversion.ListContentVersionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.contentversion.ContentVersionRecord;
      reader.readMessage(value,proto.contentversion.ContentVersionRecord.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.ListContentVersionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.ListContentVersionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.ListContentVersionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.ListContentVersionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.contentversion.ContentVersionRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ContentVersionRecord versions = 1;
 * @return {!Array<!proto.contentversion.ContentVersionRecord>}
 */
proto.contentversion.ListContentVersionsResponse.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.contentversion.ContentVersionRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.contentversion.ContentVersionRecord, 1));
};


/**
 * @param {!Array<!proto.contentversion.ContentVersionRecord>} value
 * @return {!proto.contentversion.ListContentVersionsResponse} returns this
*/
proto.contentversion.ListContentVersionsResponse.prototype.setVersionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.contentversion.ContentVersionRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.contentversion.ContentVersionRecord}
 */
proto.contentversion.ListContentVersionsResponse.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.contentversion.ContentVersionRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.contentversion.ListContentVersionsResponse} returns this
 */
proto.contentversion.ListContentVersionsResponse.prototype.clearVersionsList = function() {
  return this.setVersionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.GetContentVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.GetContentVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.GetContentVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.GetContentVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.GetContentVersionRequest}
 */
proto.contentversion.GetContentVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.GetContentVersionRequest;
  return proto.contentversion.GetContentVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.GetContentVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.GetContentVersionRequest}
 */
proto.contentversion.GetContentVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.GetContentVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.GetContentVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.GetContentVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.GetContentVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string version_id = 1;
 * @return {string}
 */
proto.contentversion.GetContentVersionRequest.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.GetContentVersionRequest} returns this
 */
proto.contentversion.GetContentVersionRequest.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.GetAvailableUpgradeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.GetAvailableUpgradeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.GetAvailableUpgradeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.GetAvailableUpgradeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.GetAvailableUpgradeRequest}
 */
proto.contentversion.GetAvailableUpgradeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.GetAvailableUpgradeRequest;
  return proto.contentversion.GetAvailableUpgradeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.GetAvailableUpgradeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.GetAvailableUpgradeRequest}
 */
proto.contentversion.GetAvailableUpgradeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.GetAvailableUpgradeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.GetAvailableUpgradeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.GetAvailableUpgradeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.GetAvailableUpgradeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.GetAvailableUpgradeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.GetAvailableUpgradeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.GetAvailableUpgradeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.GetAvailableUpgradeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hasUpgrade: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    latestVersion: (f = msg.getLatestVersion()) && proto.contentversion.ContentVersionRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.GetAvailableUpgradeResponse}
 */
proto.contentversion.GetAvailableUpgradeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.GetAvailableUpgradeResponse;
  return proto.contentversion.GetAvailableUpgradeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.GetAvailableUpgradeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.GetAvailableUpgradeResponse}
 */
proto.contentversion.GetAvailableUpgradeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasUpgrade(value);
      break;
    case 2:
      var value = new proto.contentversion.ContentVersionRecord;
      reader.readMessage(value,proto.contentversion.ContentVersionRecord.deserializeBinaryFromReader);
      msg.setLatestVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.GetAvailableUpgradeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.GetAvailableUpgradeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.GetAvailableUpgradeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.GetAvailableUpgradeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasUpgrade();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getLatestVersion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.contentversion.ContentVersionRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool has_upgrade = 1;
 * @return {boolean}
 */
proto.contentversion.GetAvailableUpgradeResponse.prototype.getHasUpgrade = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.contentversion.GetAvailableUpgradeResponse} returns this
 */
proto.contentversion.GetAvailableUpgradeResponse.prototype.setHasUpgrade = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional ContentVersionRecord latest_version = 2;
 * @return {?proto.contentversion.ContentVersionRecord}
 */
proto.contentversion.GetAvailableUpgradeResponse.prototype.getLatestVersion = function() {
  return /** @type{?proto.contentversion.ContentVersionRecord} */ (
    jspb.Message.getWrapperField(this, proto.contentversion.ContentVersionRecord, 2));
};


/**
 * @param {?proto.contentversion.ContentVersionRecord|undefined} value
 * @return {!proto.contentversion.GetAvailableUpgradeResponse} returns this
*/
proto.contentversion.GetAvailableUpgradeResponse.prototype.setLatestVersion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.GetAvailableUpgradeResponse} returns this
 */
proto.contentversion.GetAvailableUpgradeResponse.prototype.clearLatestVersion = function() {
  return this.setLatestVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.GetAvailableUpgradeResponse.prototype.hasLatestVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.DownloadContentVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.DownloadContentVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.DownloadContentVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.DownloadContentVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.DownloadContentVersionRequest}
 */
proto.contentversion.DownloadContentVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.DownloadContentVersionRequest;
  return proto.contentversion.DownloadContentVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.DownloadContentVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.DownloadContentVersionRequest}
 */
proto.contentversion.DownloadContentVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.DownloadContentVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.DownloadContentVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.DownloadContentVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.DownloadContentVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string version_id = 1;
 * @return {string}
 */
proto.contentversion.DownloadContentVersionRequest.prototype.getVersionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.DownloadContentVersionRequest} returns this
 */
proto.contentversion.DownloadContentVersionRequest.prototype.setVersionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.DownloadContentVersionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.DownloadContentVersionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.DownloadContentVersionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.DownloadContentVersionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    presignedUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.DownloadContentVersionResponse}
 */
proto.contentversion.DownloadContentVersionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.DownloadContentVersionResponse;
  return proto.contentversion.DownloadContentVersionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.DownloadContentVersionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.DownloadContentVersionResponse}
 */
proto.contentversion.DownloadContentVersionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPresignedUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.DownloadContentVersionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.DownloadContentVersionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.DownloadContentVersionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.DownloadContentVersionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPresignedUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string presigned_url = 1;
 * @return {string}
 */
proto.contentversion.DownloadContentVersionResponse.prototype.getPresignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.DownloadContentVersionResponse} returns this
 */
proto.contentversion.DownloadContentVersionResponse.prototype.setPresignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentversion.ContentVersionRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.contentversion.ContentVersionRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentversion.ContentVersionRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.ContentVersionRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contentAccountId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    majorVersion: jspb.Message.getFieldWithDefault(msg, 4, 0),
    minorVersion: jspb.Message.getFieldWithDefault(msg, 5, 0),
    title: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isMajor: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    payloadSchemaVersion: jspb.Message.getFieldWithDefault(msg, 9, 0),
    publishedByEmail: jspb.Message.getFieldWithDefault(msg, 10, ""),
    changelog: jspb.Message.getFieldWithDefault(msg, 11, ""),
    status: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentversion.ContentVersionRecord}
 */
proto.contentversion.ContentVersionRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentversion.ContentVersionRecord;
  return proto.contentversion.ContentVersionRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentversion.ContentVersionRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentversion.ContentVersionRecord}
 */
proto.contentversion.ContentVersionRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentAccountId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMajorVersion(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinorVersion(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMajor(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPayloadSchemaVersion(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishedByEmail(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangelog(value);
      break;
    case 12:
      var value = /** @type {!proto.contentversion.PublishContentVersionStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentversion.ContentVersionRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentversion.ContentVersionRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentversion.ContentVersionRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentversion.ContentVersionRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContentAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMajorVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMinorVersion();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsMajor();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getPayloadSchemaVersion();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPublishedByEmail();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getChangelog();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.contentversion.ContentVersionRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.contentversion.ContentVersionRecord.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
*/
proto.contentversion.ContentVersionRecord.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentversion.ContentVersionRecord.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string content_account_id = 3;
 * @return {string}
 */
proto.contentversion.ContentVersionRecord.prototype.getContentAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setContentAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 major_version = 4;
 * @return {number}
 */
proto.contentversion.ContentVersionRecord.prototype.getMajorVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setMajorVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 minor_version = 5;
 * @return {number}
 */
proto.contentversion.ContentVersionRecord.prototype.getMinorVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setMinorVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string title = 6;
 * @return {string}
 */
proto.contentversion.ContentVersionRecord.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_major = 8;
 * @return {boolean}
 */
proto.contentversion.ContentVersionRecord.prototype.getIsMajor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setIsMajor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 payload_schema_version = 9;
 * @return {number}
 */
proto.contentversion.ContentVersionRecord.prototype.getPayloadSchemaVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setPayloadSchemaVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string published_by_email = 10;
 * @return {string}
 */
proto.contentversion.ContentVersionRecord.prototype.getPublishedByEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setPublishedByEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string changelog = 11;
 * @return {string}
 */
proto.contentversion.ContentVersionRecord.prototype.getChangelog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setChangelog = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional PublishContentVersionStatus status = 12;
 * @return {!proto.contentversion.PublishContentVersionStatus}
 */
proto.contentversion.ContentVersionRecord.prototype.getStatus = function() {
  return /** @type {!proto.contentversion.PublishContentVersionStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.contentversion.PublishContentVersionStatus} value
 * @return {!proto.contentversion.ContentVersionRecord} returns this
 */
proto.contentversion.ContentVersionRecord.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * @enum {number}
 */
proto.contentversion.PublishContentVersionStatus = {
  PUBLISH_CONTENT_VERSION_STATUS_UNSPECIFIED: 0,
  PUBLISH_CONTENT_VERSION_STATUS_PENDING: 1,
  PUBLISH_CONTENT_VERSION_STATUS_PUBLISHED: 2,
  PUBLISH_CONTENT_VERSION_STATUS_FAILED: 3
};

goog.object.extend(exports, proto.contentversion);
